@if (collapsed()) {
  <app-button
    class="collapsed-button"
    [isPrimary]="true"
    [attr.data-testid]="testIds.buttonSearchCollapsed"
    [collapsed]="collapsed()"
    (keydown.enter)="onSearchClick()"
    (click)="onSearchClick()">
    <mat-icon svgIcon="search-icon"></mat-icon>
  </app-button>
}

@if (!collapsed()) {
  @if (groupOfForm() === undefined) {
    <div class="search-container">
      <div class="search-field">
        <input
          matInput
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchInputChange()"
          (keydown.enter)="onSearchClick()"
          [placeholder]="localPlaceholder()"
          [attr.data-testid]="dataTestId()" />

        <button
          type="button"
          matTooltip="Suche ausführen"
          matSuffix
          [attr.data-testid]="testIds.buttonSearch"
          (click)="onSearchClick()">
          <mat-icon class="search-icon" svgIcon="search-icon"></mat-icon>
        </button>
      </div>
    </div>
  } @else {
    <form [attr.data-testid]="formDataTestId()" class="search-container" [formGroup]="groupOfForm()!">
      <div class="search-field">
        <input
          matInput
          [placeholder]="localPlaceholder()"
          [attr.data-testid]="dataTestId()"
          [formControlName]="controlName()"
          (keydown.enter)="onSearchClick()"
          (change)="onSearchInputChange()" />
        <button
          type="button"
          matTooltip="Suche ausführen"
          matSuffix
          [attr.data-testid]="testIds.buttonSearch"
          (click)="onSearchClick()">
          <mat-icon class="search-icon" svgIcon="search-icon"></mat-icon>
        </button>
      </div>
    </form>
    <ng-content></ng-content>
  }
}
